import React from 'react';
import { Table, Tooltip, Button, Input, Row, Col, Icon, Spin, Modal } from 'antd';
import { openNotification } from '../../util/notificaciones';
import { sanitizerTexto } from '../../util/utilerias';
import FormSegementoPV from './FormSegementoPV';
import SegmentosPVRequest from '../../services/SegmentosPV';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';
const rol = localStorage.getItem("role")?.split(",");

export default class SegementoPV extends BaseComponent {
    state = {
        filterText: "",
        cargando: false,
        typeForm: null,
        objProveedor: null,
        arrListaArticulos: [],
        objEliminarSegmento: null,
        mostrarModalCancelar: false,
        bloquearBotones: false,
        cargandoCancelar: false,
        arrSegmentosPV: [],
        arrSegmentosPVCopy: [],
    }

    /**
     * Cargar la tabla de Segmentos
     */
    componentDidMount = () => {
        window.scrollTo(0, 0)
        this.cargarSegmentosRefresh()
    }

    /**
     * Filtrar entre los resultados según los valores establecidos en los filtros
     * @return: nada
     */
    handleSearchInput = (value) => {
        let state = { ...this.state }
        state.filterText = value;
        let arrSegmentosPVCopy = state.arrSegmentosPV;
        if (value) {
            arrSegmentosPVCopy = arrSegmentosPVCopy.filter(obj => {
                return sanitizerTexto(value, obj?.nombre ?? null)
            })
        }

        state.arrSegmentosPVCopy = arrSegmentosPVCopy;
        this.setState(state)
    }

    /**
     * Mostrarl el modal de formulario de segmentos
     * @param: type. acción que elige el segmento entre ver, editar o nuevo
     * @return: nada, se usa el valor para mostrar datos específicos
     */
    showForm = () => {
        this.setState({ visible: true, actualizar: true, })
    }

    /**
     * Función para recargar los segmentos
     */
    cargarSegmentosRefresh = () => {
        let state = { ...this.state };
        this.setState({ cargando: true, filterText: "" }, () => {
            SegmentosPVRequest.CargarSegmentosTabla()
                .then(response => {
                    state.arrSegmentosPV = response.data;
                    state.arrSegmentosPVCopy = response.data;
                    state.cargando = false;
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al cargar los segmentos",
                        "Error al cargar segmentos",
                        false
                    )
                })
        })
    }

    /**
     * Función que se encarga cancelar modal
     * value. true o false dependiendo de si
     * necesita recargar o no los proveedores
     */
    cancelModal = (value) => {
        let state = { ...this.state };
        state.visible = false;
        state.objSitio = null;
        this.setState(state)
        if (value) {
            this.cargarSegmentosRefresh();
        }
    }

    /**
     * Función que se encarga eliminar
     * a un segmento
     */
    eliminarSegmento = () => {
        let state = { ...this.state };
        this.setState({ cargandoCancelar: true, bloquearBotones: true }, () => {
            SegmentosPVRequest.EliminarSegmento(state.objEliminarSegmento.id)
                .then(response => {
                    state.cargandoCancelar = false;
                    state.bloquearBotones = false;
                    state.mostrarModalCancelar = false;
                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo,
                        true
                    )
                    state.filterText = [];
                    window.location.reload();
                })
                .catch(err => {
                    this.setState({ cargandoCancelar: false, bloquearBotones: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        err?.response?.data?.titulo,
                        false
                    )
                })
        })
    }

    render() {
        const columnasProveedores = [
            {
                title: "Nombre segmento",
                dataIndex: "nombre",
                key: "nombre",
            },
            {
                title: "Numero de segmento",
                dataIndex: "numero",
                key: "numero",
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span className={rol.includes("Administrador") ? "" : "display-none"} style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Eliminar segmento"}>
                                <Button
                                    icon="close"
                                    className="btnCancelarPedido"
                                    onClick={() => {
                                        this.setState({ objEliminarSegmento: record, mostrarModalCancelar: true })
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                    </div>
                )
            }
        ]
        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo de segmentos punto de venta"
                className="title-card"
                extra={
                    <div>
                        <Button
                            className={rol.includes("Administrador") ? "btnVerCrearGuardar" : "display-none"}
                            type="primary"
                            onClick={() => this.showForm(1, undefined, undefined)}
                        >
                            Nuevo Segmento
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div className="filters">
                        <Row gutter={8}>
                            <Col span={this.state.isPos ? 12 : 8} >
                                <Tooltip placement="top" title="Buscar por nombre">
                                    <div className="center">Segmento:</div>
                                    <Input
                                        id="userInput"
                                        type="text"
                                        maxLength={80}
                                        value={this.state.filterText}
                                        autoFocus={true}
                                        placeholder="Buscar por nombre"
                                        onChange={(e) => this.handleSearchInput(e.currentTarget.value)}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>

                    </div>
                    <br />
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table
                            size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={sitio => sitio.id}
                            pagination={{ showTitle: false }}
                            columns={columnasProveedores}
                            dataSource={this.state.arrSegmentosPVCopy}
                        />
                    </Spin>
                    <FormSegementoPV
                        visible={this.state.visible}
                        actualizar={this.state.actualizar}
                        cancel={this.cancelModal}
                        segmento_pv={this.state.objProveedor !== null && this.state.objProveedor}
                        type={this.state.typeForm}
                    />
                    <Modal
                        title={<p style={{ textAlign: "center", marginBottom: 0 }}>Confirmar</p>}
                        onCancel={() => {
                            this.setState({ mostrarModalCancelar: false })
                        }}
                        centered={true}
                        visible={this.state.mostrarModalCancelar}
                        maskClosable={false}
                        footer={[
                            <Button
                                id='regresar-boton-confirmar-eliminar-segmento'
                                className="btnCancelar"
                                key="back"
                                onClick={() => {
                                    let state = { ...this.state };
                                    state.mostrarModalCancelar = false;
                                    this.setState(state);
                                }}>
                                Regresar
                            </Button>,
                            <Button
                                id='guardar-boton-confirmar-eliminar-segmento'
                                className="btnVerCrearGuardar"
                                key="submit"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.eliminarSegmento}
                            >
                                Continuar
                            </Button>
                        ]}
                    >
                        <Spin
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargandoCancelar}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                            <p>
                                <b>¿Está seguro de eliminar el segmento?</b>
                            </p>
                        </Spin>
                    </Modal>
                </div>
            </ResponsiveCard>
        )
    }
}